import { Avatar, Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { allIcons } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";

const CustomerSupportPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  // Email validation
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Phone validation
  const isValidPhone = (phone) => {
    return phone && phone.length >= 10;
  };

  const handleSubmit = async (e) => {
    try {
      if (e) e.preventDefault();

      const { name, email, phone, message } = form;

      // Validation
      if (!name || !email || !phone || !message) {
        handleSnackbarVal(true, "error", "All fields are required.");
        return;
      }

      if (name.trim().length < 2) {
        handleSnackbarVal(
          true,
          "error",
          "Name must be at least 2 characters long."
        );
        return;
      }

      if (!isValidEmail(email)) {
        handleSnackbarVal(true, "error", "Please enter a valid email address.");
        return;
      }

      if (!isValidPhone(phone)) {
        handleSnackbarVal(true, "error", "Please enter a valid phone number.");
        return;
      }

      if (message.trim().length < 10) {
        handleSnackbarVal(
          true,
          "error",
          "Message must be at least 10 characters long."
        );
        return;
      }

      setIsLoading(true);

      // Simulate API call
      setTimeout(() => {
        setIsLoading(false);
        handleSnackbarVal(
          true,
          "success",
          "Your message has been sent successfully! We'll get back to you soon."
        );

        // Reset form
        setForm({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      }, 2000);
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(
        true,
        "error",
        "Something went wrong. Please try again."
      );
    }
  };

  return (
    <Box sx={{ maxWidth: "800px", margin: "0 auto", padding: "24px" }}>
      <Stack
        p={2}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ borderBottom: "1px solid #e0e0e0", mb: 3 }}
      >
        {/* <Stack direction="row" alignItems="center" gap={2}>
          <img
            src={allIcons.landingHeadphoneIcon}
            alt="Headphone-icon"
            width={35}
          />
          <Box>
            <Typography
              variant="h1"
              fontSize="1.125rem"
              color="primary.main"
              fontWeight={600}
            >
              Live Support
            </Typography>
            <Typography variant="body2" color="#868E96">
              24/7 we are available
            </Typography>
          </Box>
        </Stack> */}
      </Stack>

      <Box>
        <Typography variant="h5" fontWeight={700} textAlign="center" mb={3}>
          Contact Us Over
        </Typography>

        <Stack alignItems="center" mb={4}>
          <Chip
            sx={{
              my: 2,
              border: "1px solid #08AD36",
              "& .MuiChip-label": { color: "#08AD36" },
              cursor: "pointer",
            }}
            avatar={<Avatar alt="WhatsApp" src={allIcons.whatsAppLogoColor} />}
            label="WhatsApp"
            variant="outlined"
            onClick={() => window.open("https://wa.me/966536651383", "_blank")}
          />
        </Stack>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ maxWidth: 600, margin: "auto" }}
        >
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12}>
              <Label labelText="Name" required />
              <TextInput
                placeholder="Enter your name"
                value={form.name}
                onChange={(e) => handleChange("name", e.target.value)}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText="Email address" required />
              <TextInput
                placeholder="Enter your email address"
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText="Phone Number" required />
              <PhoneInput
                country="us"
                value={form.phone}
                onChange={(phone) => handleChange("phone", phone)}
                inputClass="cutom-phone-input"
                buttonClass="custom-phone-input-button"
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText="Your Message" required />
              <TextInput
                placeholder="Enter your message"
                multiline
                rows={4}
                value={form.message}
                onChange={(e) => handleChange("message", e.target.value)}
                disabled={isLoading}
              />
            </Grid>
          </Grid>

          <Stack alignItems="center">
            <GlobalButton
              btnText={isLoading ? "Sending..." : "Send"}
              handleClickBtn={handleSubmit}
              disabled={isLoading}
            />
          </Stack>
        </Box>
      </Box>

      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Loader isLoading={isLoading} />
    </Box>
  );
};

export default CustomerSupportPage;
